import { createTheme, responsiveFontSizes } from "@material-ui/core/styles";

let hocTheme = createTheme({
    overrides: {
        MuiCheckbox: {
            colorSecondary: {
                color: "#333F48",
                "&$checked": {
                    color: "#333F48",  
                },
            },
        },
        MuiRadio: {
            colorSecondary: {
                color: "#333F48",
                "&$checked": {
                    color: "#333F48",  
                },
            },
        },
        MuiTypography: {
            colorTextSecondary: {
                color: "#fff"
            },
        },
    },
    palette: {
        primary: {
            main: "#009EDF",
            contrastText: "#FFFFFF",
            dark: "#007AAD",
            light: "#36C5FF"
        },
        secondary: {
            main: "#333F48",
            contrastText: "#FFFFFF",
            dark: "#20272D",
            light: "#4F6372"
        },
        error: {
            main: "#EF2C30",
            contrastText: "#FFFFFF",
            dark: "#CB1316",
            light: "#FF494E"
        },
        text: {
            primary: "#363636",
            secondary: "#363636",
            hint: "#666666",
            disabled: "#c4c4c4"
        }
    },
    typography: {
        fontFamily: "Open Sans, sans-serif",
    }
});


hocTheme = responsiveFontSizes(hocTheme);

export default hocTheme;